import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

import { BodyText } from '../styles'

export const LogoutWrapper = styled(FocusNode)`
  height: 100vh;
  padding: 0 104px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const ContentWrapper = styled('div')`
  display: flex;
  width: auto;
  margin: 0 auto;
  flex-direction: column;
  align-items: flex-start;
`

export const MobileApp = styled('div')`
  display: flex;
  height: 542px;
  width: 1115px;
  flex-direction: row;
  justify-content: center;
  margin-top: 60px;
`

export const MobileAppImgWrapper = styled('div')`
  height: 542px;
  flex: 0 0 288px;
`

export const MobileAppImg = styled.img`
  object-fit: cover;
`

export const MobileAppDescription = styled('div')`
  width: auto;
  padding: 40px 75px;
`

export const TextElem = styled('div')`
  margin-bottom: 48px;
  color: ${(props) => props.theme.colors.logout.text};
  font-weight: 500;
  font-size: 20px;
  line-height: 1.5;
`

export const Row = styled('div')`
  display: flex;
`

export const StoreImg = styled.img`
  display: flex;
  width: 160px;
  height: 53px;
  margin: 0 0 0 32px;
`

export const ContentBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  min-height: 300px;
  margin-bottom: 35px;
`

export const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 750px;
`

export const ImportantBodyText = styled(BodyText)`
  color: ${(props) => props.theme.colors.logout.title};
  font-size: 28px;
  font-weight: bold;
  text-align: center;
`
